<template>
  <div class="modalTable">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button type="primary" @click="clearRadioRowEevnt"
          >取消选中</el-button
        >
        <el-button type="primary" @click="getRadioEvent1">获取选中</el-button>
        <el-button type="primary" @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="80%"
      border
      auto-resize
      class="radio-table"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="userName" title="姓名" min-width="150" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="公司名称"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          :formatter="formatterStaffType"
          field="staffType"
          title="托运人类型"
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.staffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in staffTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="电话号码" min-width="180" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { findShipper } from "@/api/orderform";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        staffTypes: "0,1",
        authStatus: 3
      },
      Pagingconf: [],
      tableData: [],
      staffTypeOptions: [
        { value: 0, label: "个体托运人" },
        { value: 1, label: "企业" }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {},
  methods: {
    close() {
      this.listQuery = {
        name: "",
        phone: "",
        createdBy: "",
        gmtCreated: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        staffTypes: "0,1",
        authStatus: 3
      };
    },
    //查询代发托运人
    shipmentlist() {
      this.loading = true;
      findShipper(this.listQuery).then(response => {
        this.loading = false;
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    //获取选中
    getRadioEvent1() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (this.getdata) {
        this.$emit("event1", this.getdata);
      } else {
        this.$message({ message: "请选择一个代发托运人", type: "warning" });
      }
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    },
    // 翻译状态
    formatterStaffType({ cellValue }) {
      const item = this.staffTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
